import { Routes } from '@angular/router';

import { PartnerInscriptionLeaveGuard } from '../core/guards/partner-inscription-leave.guard';
import { PartnerInscriptionStepGuard } from '../core/guards/partner-inscription-step.guard';
import { PartnerInscriptionSuccessGuard } from '../core/guards/partner-inscription-success.guard';
import { CadastroParceirosComponent } from '../pages/cadastro-parceiros/cadastro-parceiros.component';
import { CadastroParceirosFormComponent } from '../pages/cadastro-parceiros/cadastro-parceiros-form.component';

export const partnerRoutes: Routes = [
  {
    path: 'cadastro-parceiros/inscricao',
    pathMatch: 'full',
    redirectTo: 'cadastro-parceiros/inscricao/comece-aqui',
  },
  {
    path: 'cadastro-parceiros/inscricao/comece-aqui',
    component: CadastroParceirosFormComponent,
  },
  {
    path: 'cadastro-parceiros/inscricao/step-1',
    component: CadastroParceirosFormComponent,
    canActivate: [PartnerInscriptionStepGuard],
    canDeactivate: [PartnerInscriptionLeaveGuard],
  },
  {
    path: 'cadastro-parceiros/inscricao/step-2',
    component: CadastroParceirosFormComponent,
    canActivate: [PartnerInscriptionStepGuard],
    canDeactivate: [PartnerInscriptionLeaveGuard],
  },
  {
    path: 'cadastro-parceiros/inscricao/step-3',
    component: CadastroParceirosFormComponent,
    canActivate: [PartnerInscriptionStepGuard],
    canDeactivate: [PartnerInscriptionLeaveGuard],
  },
  {
    path: 'cadastro-parceiros/inscricao/step-3/success',
    component: CadastroParceirosFormComponent,
    canActivate: [PartnerInscriptionSuccessGuard],
  },
  {
    path: 'cadastro-parceiros',
    component: CadastroParceirosComponent,
  },
];
